/**
 * Utility functions for handling autofill data in the Drawdown Tool
 */

import { DATA_SOURCES, UNITS } from "../constants/drawdownConstants";

/**
 * Processes autofill data and converts it to form data format
 * @param {Object} autofillData - Raw autofill data from previous run
 * @param {Array} aquifers - Available aquifer options
 * @param {Array} units - Available unit options
 * @returns {Object} Processed form data
 */
export const processAutofillData = (autofillData, aquifers, units) => {
  if (!autofillData || !aquifers.length || !units.length) {
    return null;
  }

  // Find aquifer_ndx by matching source_aquifer name to aquifer_name
  const matchingAquifer = aquifers.find(
    (aquifer) => aquifer.aquifer_name === autofillData.source_aquifer
  );

  // Find unit_ndx for "Feet" (model always converts to feet)
  const feetUnit = units.find(
    (unit) => unit.remark === UNITS.FEET || unit.remark === UNITS.FEET_LOWERCASE
  );

  return {
    latitude_dd: autofillData.y?.toString() || "",
    longitude_dd: autofillData.x?.toString() || "",
    proposed_well_name: autofillData.proposed_well_name || "",
    aquifer_ndx: matchingAquifer?.aquifer_ndx?.toString() || "",
    distance_radius: autofillData.search_radius_ft?.toString() || "",
    distance_units: feetUnit?.unit_ndx?.toString() || "",
    proposed_annual_af: autofillData.annual_af_requested?.toString() || "",
    proposed_rate_gpm: autofillData.discharge_gpm?.toString() || "",
    use_custom_t: autofillData.trans_source !== DATA_SOURCES.GAM_DATASET,
    custom_transmissivity:
      autofillData.trans_source !== DATA_SOURCES.GAM_DATASET
        ? autofillData.modeled_transmissivity?.toString() || ""
        : "",
    use_custom_s: autofillData.stor_source !== DATA_SOURCES.GAM_DATASET,
    custom_storativity:
      autofillData.stor_source !== DATA_SOURCES.GAM_DATASET
        ? autofillData.modeled_storativity?.toString() || ""
        : "",
    run_notes: autofillData.run_notes || "",
  };
};
